<template>
  <svg
    width="240"
    height="240"
    viewBox="0 0 240 240"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="240" height="240" fill="white" />
    <rect
      x="149"
      y="161.314"
      width="16"
      height="24"
      transform="rotate(-45 149 161.314)"
      fill="#20518C"
    />
    <rect
      x="159.184"
      y="177.512"
      width="24.5056"
      height="29.3451"
      transform="rotate(-45 159.184 177.512)"
      fill="#A0CDFC"
    />
    <rect x="64" y="64" width="112" height="112" rx="56" fill="#A0CDFC" />
    <rect x="80" y="80" width="80" height="80" rx="40" fill="white" />
    <rect
      x="105.859"
      y="111.516"
      width="8"
      height="32"
      transform="rotate(-45 105.859 111.516)"
      fill="#20518C"
    />
    <rect
      width="8"
      height="32"
      transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 134.141 111.516)"
      fill="#20518C"
    />
    <rect
      opacity="0.5"
      x="84"
      y="84"
      width="72"
      height="72"
      rx="36"
      fill="url(#paint0_linear_145_4186)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_145_4186"
        x1="120"
        y1="84"
        x2="120"
        y2="156"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.495192" stop-color="#A0CDFC" stop-opacity="0" />
        <stop offset="1" stop-color="#A0CDFC" />
      </linearGradient>
    </defs>
  </svg>
</template>
